export const stageAddressLifeCycleTypes = {
  CONSTRUCTION: 1, // Строительство
  INTERNAL_ACCEPTANCE: 2, // Внутренняя приемка
  ACCEPTANCE: 3, // Приемка
  MANAGEMENT: 4, // Управление
};

export const stageAddressLifeCycleNames = {
  [stageAddressLifeCycleTypes.CONSTRUCTION]: 'Строительство',
  [stageAddressLifeCycleTypes.INTERNAL_ACCEPTANCE]: 'Внутренняя приемка',
  [stageAddressLifeCycleTypes.ACCEPTANCE]: 'Приемка',
  [stageAddressLifeCycleTypes.MANAGEMENT]: 'Управление',
};

export const stepAddressLifeCycleTypes = {
  WORK_UNDERWAY: 1, // Идут работы
  WORK_COMPLETED: 2, // Работы завершены
  NOT_READY_TRANSMISSION: 3, // Не готова к передаче
  READY_TRANSMISSION: 4, // Готова к передаче
  INVITATION: 5, // Приглашение на приемку
  REGISTERED_ISSUE: 6, // Зарегистрирована приемка
  OWNER_NOT_SHOW_UP: 7, // Владелец не явился
  EXPLOITATION: 8, // Эксплуатация
};

export const NOT_ACCEPTED = 1; // Не принято (Статус приемки)

export const stageToStepMap = {
  [stageAddressLifeCycleTypes.CONSTRUCTION]: {
    default: stepAddressLifeCycleTypes.WORK_UNDERWAY,
    steps: [
      stepAddressLifeCycleTypes.WORK_UNDERWAY,
      stepAddressLifeCycleTypes.WORK_COMPLETED,
    ],
  },

  [stageAddressLifeCycleTypes.INTERNAL_ACCEPTANCE]: {
    default: stepAddressLifeCycleTypes.NOT_READY_TRANSMISSION,
    steps: [
      stepAddressLifeCycleTypes.NOT_READY_TRANSMISSION,
      stepAddressLifeCycleTypes.READY_TRANSMISSION,
    ],
  },

  [stageAddressLifeCycleTypes.ACCEPTANCE]: {
    default: stepAddressLifeCycleTypes.INVITATION,
    steps: [
      stepAddressLifeCycleTypes.INVITATION,
      stepAddressLifeCycleTypes.REGISTERED_ISSUE,
      stepAddressLifeCycleTypes.OWNER_NOT_SHOW_UP,
    ],
  },

  [stageAddressLifeCycleTypes.MANAGEMENT]: {
    default: stepAddressLifeCycleTypes.EXPLOITATION,
    steps: [stepAddressLifeCycleTypes.EXPLOITATION],
  },
};
